import { api, Response, STATUS } from "../constants/api";
import { UserType } from "../constants/user";
import { get, put } from "../utils/request";

export const getUserById = async (userId: string | null): Promise<Response> => {
  let errorMessage = "No user id provided";

  if (userId) {
    const res = await get(`${api.user}/${userId}`);

    if (res?.status === STATUS.SUCCESS) {
      return { result: res?.data, success: true };
    } else {
      errorMessage = res?.data;
    }
  }

  return { result: errorMessage, success: false };
};

export const updateUserInfo = async (
  userId: string | null,
  payload: UserType,
): Promise<Response> => {
  let errorMessage = "No user id provided";

  if (userId) {
    const res = await put(`${api.user}/${userId}`, payload);
    if (res?.status === STATUS.SUCCESS) {
      return { result: res?.data, success: true };
    } else {
      errorMessage = res?.data;
    }
  }

  return { result: errorMessage, success: false };
};
